// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.7',
  revision: '04ce10699',
  branch: 'master',
  date: 'Tue, 23 Jun 2026 09:53:19 GMT'
};